import { Link } from "react-router-dom";
import { typeLabel, type Media } from "@/mocks/media";

interface MediaCardProps {
  media: Media;
  compact?: boolean;
}

export default function MediaCard({ media, compact = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${media.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className={`relative w-full overflow-hidden bg-background-200 ${compact ? "h-[180px]" : "aspect-[6/8.4]"}`}>
        <img
          src={media.cover}
          alt={`${media.title} 封面`}
          title={`${media.title} ${typeLabel[media.type]} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute top-2 left-2 px-2 h-6 inline-flex items-center rounded-md bg-primary-900/90 text-background-50 text-[11px] font-medium">
          {typeLabel[media.type]}
        </span>
        <span className="absolute top-2 right-2 px-2 h-6 inline-flex items-center rounded-md bg-secondary-500 text-foreground-950 text-[11px] font-bold">
          {media.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 pt-8 pb-2 px-2 bg-gradient-to-t from-primary-950/85 to-transparent">
          <span className="text-[11px] text-background-100 line-clamp-1">{media.status}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
          {media.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 truncate">
          {media.year} · {media.region} · {media.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}